import React from "react";
import MultiSelectField from "./MultiSelectField";
export default function SelectServiceLinesPlus({ options, ...field }) {
  return <MultiSelectField {...field} options={options} />;
}
